export interface ZonedDateTime {
  date: Date;
  hours: number;
  minutes: number;
}

// Reads the standard UTC offset from a display name such as "(UTC+05:30) Chennai, Kolkata" and returns it in minutes, or null when absent.
export function getUtcOffsetMinutes(displayName: string | undefined): number | null {
  const match = /\(UTC(?:([+-])(\d{2}):(\d{2}))?\)/.exec(displayName ?? '');
  if (!match) {
    return null;
  }
  if (!match[1]) {
    return 0;
  }
  const sign = match[1] === '-' ? -1 : 1;
  return sign * (Number(match[2]) * 60 + Number(match[3]));
}

// Returns the current wall-clock date and time at the given UTC offset.
export function getCurrentDateTimeAtOffset(offsetMinutes: number): ZonedDateTime {
  const shifted = new Date(Date.now() + offsetMinutes * 60000);
  return {
    date: new Date(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate()),
    hours: shifted.getUTCHours(),
    minutes: shifted.getUTCMinutes()
  };
}
